module.exports = __webpack_public_path__ + "static/pc_casestudy_glamira-4e284f4c939678e6bd5459d15e211005.jpg";